import { stringify } from 'qs';
import partners from '../models/partners';
import request from '../utils/request';

export async function getList(params) {
  console.log(params, 'pppp')
  return request(`/partner/card-codes?${stringify(params)}`);
}

export async function get(code, params = {}) {
  let result = request(`/partner/card-codes/${code}`, { params });
  return result;
}

export async function create(body) {
  return request(`/`, {
    method: 'POST',
    body,
  });
}

export async function update(id, body) {
  return request(`/partner/card-codes/${id}`, {
    method: 'POST',
    body,
  });
}
export async function generateCardCode(params) {
  return request(`/partner/card-codes`, {
    method: 'POST',
    body: params,
  });
}

